"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onModalEvent = exports.closeModal = exports.confirmDelete = exports.getFlagUrl = void 0;
function getFlagUrl(iso_639_1) {
    var flagIdentifier = iso_639_1.toUpperCase();
    // TODO: Pass url to function 'getUrlTo()' before returning it
    return "/admin_resources/images/flags/".concat(flagIdentifier, ".png");
}
exports.getFlagUrl = getFlagUrl;
// TODO: Function should be imported from common.js
//  - import {confirmDelete} from '../../admin/js/common';
function confirmDelete(emptyTrash) {
    if (emptyTrash === void 0) { emptyTrash = false; }
    var action = 'delete';
    if (emptyTrash) {
        action = 'empty the trash';
    }
    var message = 'Are you sure you want to ' + action + '?';
    return confirm(message);
}
exports.confirmDelete = confirmDelete;
function closeModal(selector) {
    // @ts-ignore
    $(selector).modal('hide');
}
exports.closeModal = closeModal;
function onModalEvent(selector, eventName, eventHandler) {
    // @ts-ignore
    $(selector).on(eventName, eventHandler);
}
exports.onModalEvent = onModalEvent;
